/* eslint-disable no-console */
import {IPaginatedSearch} from '../incase-domain/search';
import {httpPost} from './http.service';
import {INotification, INotificationResponse, NotificationStatus} from '../incase-domain/notification';

export const fetchNotifications = (paginatedSearch: IPaginatedSearch, status: NotificationStatus[]): Promise<INotificationResponse> => {
    const {pageNumber, pageSize, ...searchObj} = paginatedSearch;
    return httpPost(`editor/notifications/${pageNumber}/${pageSize}/`, {searchObj, status});
};

export const updateNotification = (notification: INotification): Promise<INotification> => {
    return httpPost(`editor/notifications/updateStatus`, notification);
};

export const markNotificationAsSeen = (notificationIds: string[]): Promise<void> => {
    return httpPost(`editor/notifications/markAsSeen`, notificationIds).catch((error) => {
        console.log(error);
    });
};
